module.exports = __webpack_public_path__ + "static/media/1.6e32c081.png";